<div class="ps-0 pe-2 pb-3 pt-3">
    <div class="input-group">
        <input type="text" class="form-control" [(ngModel)]="searchTerm" (ngModelChange)="onSearchChange($event)"
               [placeholder]="searchPlaceholder | translate">
        <button class="btn btn-outline-secondary" *ngIf="searchTerm" (click)="clearSearch()" aria-label="Clear">
            <i class="fa fa-times"></i>
        </button>
    </div>
</div>
<cdk-virtual-scroll-viewport
        [itemSize]="20"
        class="virtual-scroll-viewport custom-scroll-style"
        (scrolledIndexChange)="onScroll($event)">

    <div *cdkVirtualFor="let item of locations$ | async" (click)="onItemSelect(item, $event)" class="item"
         [class.selected]="isItemSelected(item)"
         [class.field]="item.location.type === LocationTypeEnum.FIELD"
         [class.block]="item.location.type === LocationTypeEnum.BLOCK">
        <div *ngIf="!isItemEditing(item)" class="item-content text-truncate"  [title]="(model(item) && model(item).name) || item.location.name" (click)="onItemSelect(item, $event)">
            {{ (model(item) && model(item).name) || item.location.name }}
        </div>
        <div *ngIf="!isItemEditing(item)" class="item-actions">
            <button class="action-btn edit-btn" (click)="onEdit(item, $event)" [disabled]="isButtonDisabled()">
                <i class="fa fa-edit"></i>
            </button>
            <button class="action-btn delete-btn" (click)="onDelete(item, $event)" [disabled]="isButtonDisabled()">
                <i class="fa fa-trash-o"></i>
            </button>
        </div>
        <div *ngIf="isItemEditing(item)" class="item-input-editing">
            <input type="text" [(ngModel)]="model(item).name" maxlength="60" class="form-control item-editing">
        </div>
    </div>
    <div *ngIf="(locations$ | async)?.length === 0" class="no-records">
        <p>{{ 'field-manager.study-instances.no.records' | translate }}</p>
    </div>
    <div *ngIf="loading" class="loading-spinner">
        {{ 'field-manager.action.loading' | translate }}
    </div>
</cdk-virtual-scroll-viewport>
